import axios from 'axios';
import { API_HOST } from '../consts';

const fetchAddressKind = async (params) => {
  const res = await axios.get(`${API_HOST}/persons/address_kind`, { params });
  return res.data;
};

export default fetchAddressKind;
